module.exports = "8cbb9247b20924f6e487dff89dc205ea.ogg";


//////////////////
// WEBPACK FOOTER
// ./assets/music/track1.ogg
// module id = 83
// module chunks = 0